// handlers/emotionHandler2.js

import { createDataPointProcessor } from "../utils/dataPointProcessor";
import { applyLineGraphState } from "../utils/lineGraphState";
import {
  initializeDictionaries,
  initializeEmotionDict,
  initializeActionDictionaries,
} from "../utils/dictionaries";
import {
  transform,
  transformActions,
  transformFilteredData,
  transformAllActions,
  computeParticipationPercentChange,
} from "../utils/transformers";
import {
  processAllDistricts,
  processAllSchoolsInDistrict,
  processSpecificSchool,
} from "../utils/processSchools";
import {
  processSpecificClass,
  processSpecificStudent,
} from "../utils/processClasses";
import moment from "moment";

export function handleEmotion(state, emotion) {
  const { currentDict, compareDict } = initializeDictionaries();
  const { currentActionDict, compareActionDict } =
    initializeActionDictionaries();
  const currentParticipants = new Set();
  const compareParticipants = new Set();
  let impactfulActions = { action: {}, emotion: {} };
  let updateState = {};
  let filterDataPoints = [];
  let studentEmotionData = {};
  let studentSupportData = {};
  const bigFiveFilteredData = [];
  const lineGraphSourceData = [];
  let tooltipCounts = initializeEmotionDict();
  const now = moment();
  const currentDate = moment().subtract(state.filterAmountCurrent);
  const compareDate = moment().subtract(
    state.filterAmountCurrent + state.filterAmountCompare
  );
  let allEmotions = state.multiEmotion.emotions;

  const processDataPoint = createDataPointProcessor(
    currentDate,
    compareDate,
    now,
    emotion,
    currentDict,
    compareDict,
    currentActionDict,
    compareActionDict,
    impactfulActions,
    filterDataPoints,
    studentEmotionData,
    studentSupportData,
    bigFiveFilteredData,
    state.selectedTimes,
    state.selectedSubOptions,
    state.helpfulFilter,
    tooltipCounts,
    currentParticipants,
    compareParticipants,
    allEmotions,
    lineGraphSourceData
  );

  if (state.chosenDistrict === "All Districts") {
    processAllDistricts(state, processDataPoint);
  } else if (state.chosenSchool === "All Schools") {
    processAllSchoolsInDistrict(state, processDataPoint);
  } else if (state.chosenClass === "All Classes") {
    processSpecificSchool(state, state.chosenSchool, processDataPoint);
  } else if (state.chosenStudent === "All Students") {
    processSpecificClass(state, state.chosenClass, processDataPoint);
  } else {
    processSpecificStudent(state, state.chosenStudent, processDataPoint);
  }

  updateState.filteredDataPoints = filterDataPoints;
  applyLineGraphState(updateState, lineGraphSourceData, state.chosenTime, now);
  updateState.chosenEmotion = emotion;

  const emotionColorMapping = {
    sad: "#C9E2FB",
    tired: "#C9E2FB",
    lonely: "#C9E2FB",
    happy: "#C8FADD",
    grateful: "#C8FADD",
    calm: "#C8FADD",
    stressed: "#D2BCE5",
    scared: "#D2BCE5",
    angry: "#D2BCE5",
    "all emotions": "#C8FADD",
  };

  updateState.chosenColor = emotionColorMapping[emotion];
  // updateState.tieredSupportSelectedColor = emotionColorMapping[emotion];
  //  these should not impact this data so dont change it
  // updateState.bigFiveFilteredData = bigFiveFilteredData;

  transform(currentDict, compareDict, updateState);
  transformActions(impactfulActions, updateState);
  transformAllActions(currentActionDict, compareActionDict, updateState);
  transformFilteredData(
    studentEmotionData,
    state.chosenPercentage,
    updateState
  );
  computeParticipationPercentChange(
    currentParticipants,
    compareParticipants,
    updateState
  );

  return updateState;
}
